import React from 'react';
import Modal from '../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import EPrescriptionMedicamentsHVLPForm, {
	EPrescriptionHVLPMedicament,
} from './EPrescriptionMedicamentsHVLPForm';
import EPrescriptionMedicamentsIPLPForm, {
	EPrescriptionIPLPMedicament,
} from './EPrescriptionMedicamentsIPLPForm';
import { EPrescriptionMedicament } from './EPrescriptionMedicamentsWrapper';
import { Size } from '../../../Enums/Size.enum';
import { PrescriptionType } from '../../../Enums/PrescriptionType.enum';

interface EPrescriptionMedicamentsModalProps {
	isOpen: boolean;
	prescriptionType: PrescriptionType;
	onClose: () => void;
	onSubmit: (values: EPrescriptionMedicament) => void;
	size: Size;
	defaultValues?: EPrescriptionMedicament;
	patientId: string;
	isSelfPayer: boolean;
}

const EPrescriptionMedicamentsModal: React.FC<
	EPrescriptionMedicamentsModalProps
> = ({
	isOpen,
	prescriptionType,
	onClose,
	onSubmit,
	size,
	defaultValues,
	patientId,
	isSelfPayer,
}) => {
	const { isCase } = useTreatmentContext();

	const handleSubmit = (
		values: EPrescriptionHVLPMedicament | EPrescriptionIPLPMedicament,
	) => {
		onSubmit(values);
		onClose();
	};

	const isHVLP = prescriptionType === PrescriptionType.HVLP;

	return (
		<div>
			<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={size}>
				<Modal.Header
					title={
						isHVLP
							? 'component.ePrescription.addItemHVLP'
							: 'component.ePrescription.addItemIPLP'
					}
				/>
				<Modal.Content>
					{isHVLP ? (
						<EPrescriptionMedicamentsHVLPForm
							onSubmit={handleSubmit}
							defaultValues={defaultValues}
							patientId={patientId}
							isSelfPayer={isSelfPayer}></EPrescriptionMedicamentsHVLPForm>
					) : (
						<EPrescriptionMedicamentsIPLPForm
							onSubmit={handleSubmit}
							defaultValues={defaultValues}
							patientId={patientId}
							isSelfPayer={isSelfPayer}></EPrescriptionMedicamentsIPLPForm>
					)}
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default EPrescriptionMedicamentsModal;
